import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col flex-1" };
import ModuleState from "@/shared/components/ModuleState.vue";
import ModuleLoading from "@/shared/components/ModuleLoading.vue";
import HouseholdCard from "./HouseholdCard.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactRelationsFoyerTab',
    props: {
        household: {},
        loading: { type: Boolean },
        loadError: { type: Boolean },
        canEdit: { type: Boolean },
        disabledTooltip: {}
    },
    emits: ["create", "edit", "delete", "retry"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.loading)
                    ? (_openBlock(), _createBlock(ModuleLoading, { key: 0 }))
                    : (__props.loadError)
                        ? (_openBlock(), _createBlock(ModuleState, {
                            key: 1,
                            type: "error",
                            class: "flex-1",
                            title: _ctx.$t('contact.detail.relations.foyer.loadError.title'),
                            "cta-icon": "ri-refresh-line",
                            "cta-label": _ctx.$t('common.retry'),
                            onCta: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('retry')))
                        }, null, 8 /* PROPS */, ["title", "cta-label"]))
                        : (!__props.household)
                            ? (_openBlock(), _createBlock(ModuleState, {
                                key: 2,
                                type: "empty",
                                class: "flex-1 flex items-center justify-center",
                                title: _ctx.$t('contact.detail.relations.foyer.empty.title'),
                                description: _ctx.$t('contact.detail.relations.foyer.empty.description'),
                                "cta-icon": "ri-add-line",
                                "cta-label": _ctx.$t('contact.detail.relations.foyer.empty.cta'),
                                "cta-disabled": !__props.canEdit,
                                "cta-disabled-tooltip": __props.disabledTooltip,
                                onCta: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('create')))
                            }, null, 8 /* PROPS */, ["title", "description", "cta-label", "cta-disabled", "cta-disabled-tooltip"]))
                            : (_openBlock(), _createBlock(HouseholdCard, {
                                key: 3,
                                household: __props.household,
                                "can-edit": __props.canEdit,
                                "disabled-tooltip": __props.disabledTooltip,
                                onEdit: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('edit'))),
                                onDelete: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('delete')))
                            }, null, 8 /* PROPS */, ["household", "can-edit", "disabled-tooltip"]))
            ]));
        };
    }
});
